<template>
  <div class="col-sm-12 col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="animated fadeIn">
          <div class="col-md-12">
            <div class="animated fadeIn">
              <div class="modal fade show " id="modal-mapa" tabindex="-1" role="dialog"
                aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
                data-backdrop="static" v-if="showModalMapa">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-body">
                      <a class="close" data-dismiss="modal" aria-label="Fechar" style=" z-index: 1000000; font-size: 69px; color: #000; float: right; right: 0; position: absolute; top: -40px; opacity: 1;" v-on:click="showModalMapa = false">
                        <span aria-hidden="true">&times;</span>
                      </a>
                      <gmap-map
                        :center="center"
                        :zoom="15"
                        ref="map"
                        :options="{ gestureHandling: 'greedy'}"
                        style="width:calc(100vw - 28px);  height: calc(100vh - 64px)"
                      >
                        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                          <span v-html="infoContent"></span>
                        </gmap-info-window>
                        <gmap-marker
                          :key="index"
                          v-for="(m, index) in markers"
                          :position="m.position"
                          @click="toggleInfoWindow(m,index)"
                        ></gmap-marker>
                      </gmap-map>  
                      
                    </div>
                    <!-- <div class="modal-footer">
                      <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMapa = false">Fechar</button>
                    </div> -->
                  </div>
                </div>
              </div>
              
              <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
                aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
                data-backdrop="static" v-if="showModalDadosVeiculo">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4 class="modal-title">Dados do Veículo</h4>
                    </div> 
                    <div class="modal-body">                  
                        <div class="tabbable">
                          <!-- Only required for left/right tabs -->
                          <ul class="nav nav-tabs">
                            <li class="nav-item active"><a href="#tab1" data-toggle="tab" class="nav-link active">Veículo</a></li>
                            <li class="nav-item"><a href="#tab2" data-toggle="tab" class="nav-link" v-on:click="buscarGridDadosVeiculoContatoCliente(), buscarGridDadosVeiculoContatoClientePaga()" >Contatos</a></li>
                            <li class="nav-item"><a href="#tab3" data-toggle="tab" class="nav-link" v-on:click="buscarGridDadosVeiculoAcoesCliente()" >Ações</a></li>
                          </ul>

                          <div class="tab-content">
                            <div class="tab-pane active" id="tab1">
                              <div class="row">
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Data da Cadastro</strong></label><br>
                                  {{dadosVeiculo.veiculoDataCadastro}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Marca</strong></label><br>
                                  {{dadosVeiculo.veiculoMarca}}
                                </div>
                                <div class="form-group col-sm-4 col-md-4">
                                  <label><strong>Modelo</strong></label><br>
                                  {{dadosVeiculo.veiculoModelo}}
                                </div>
                              </div>                 
                              <div class="row">
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Data da instalação</strong></label><br>
                                  {{dadosVeiculo.equipamentoDataInstalacao}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Serial</strong></label><br>
                                  {{dadosVeiculo.equipamentoSerial}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Marca</strong></label><br>
                                  {{dadosVeiculo.equipamentoMarca}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Modelo</strong></label><br>
                                  {{dadosVeiculo.equipamentoModelo}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Operadora</strong></label><br>
                                  {{dadosVeiculo.equipamentoOperadora}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Numero do Chip</strong></label><br>
                                  {{dadosVeiculo.equipamentoNumero}}
                                </div>
                              </div>

                              
                              <div class="row">
                                <div class="form-group col-sm-12 col-md-12">
                                  <label><strong>Observação</strong></label><br>
                                  {{dadosVeiculo.veiculoObservação01}}
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-sm-12 col-md-12">
                                  <label><strong>Observação</strong></label><br>
                                  {{dadosVeiculo.veiculoObservação02}}
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-sm-12 col-md-12">
                                  <label><strong>Senha</strong></label><br>
                                  {{dadosVeiculo.veiculoSenha}}
                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-sm-4 col-md-4">
                                  <label><strong>Cliente</strong></label><br>
                                  {{dadosVeiculo.clienteNome}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Telefone</strong></label><br>
                                  {{dadosVeiculo.clienteTelefone}}
                                </div>
                                <div class="form-group col-sm-6 col-md-6">
                                  <label><strong>Email</strong></label><br>
                                  {{dadosVeiculo.clienteEmail}}
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-sm-4 col-md-4">
                                  <label><strong>Cliente Paga</strong></label><br>
                                  {{dadosVeiculo.clientePagaNome}}
                                </div>
                                <div class="form-group col-sm-2 col-md-2">
                                  <label><strong>Telefone</strong></label><br>
                                  {{dadosVeiculo.clientePagaTelefone}}
                                </div>
                                <div class="form-group col-sm-6 col-md-6">
                                  <label><strong>Email</strong></label><br>
                                  {{dadosVeiculo.clientePagaEmail}}
                                </div>
                              </div>
                            </div>
                            <div class="tab-pane" id="tab2">

                               <table id="contatosAdicionais"
                                  class="responsive datatable_ajax display table table-striped table-hover"
                                  width="100%">
                                  <thead class="thead-light">
                                    <th>Nome</th>
                                    <th>Telefone</th>
                                    <th>Email</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(contato, i) in dadosVeiculoContatoCliente">
                                        <td>{{contato.nome}}</td>
                                        <td>{{contato.telefone}}</td>
                                        <td>{{contato.email}}</td>  
                                    </tr>
                                  </tbody>
                                </table>

                                <table id="contatosAdicionais"
                                  class="responsive datatable_ajax display table table-striped table-hover"
                                  width="100%">
                                  <thead class="thead-light">
                                    <th>Nome</th>
                                    <th>Telefone</th>
                                    <th>Email</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(contato, i) in dadosVeiculoContatoClientePaga">
                                        <td>{{contato.nome}}</td>
                                        <td>{{contato.telefone}}</td>
                                        <td>{{contato.email}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                                  
                            </div>
                            <div class="tab-pane" id="tab3">
                              
                              <div class="row">
                                <div class="col-md-12 form-group">
                                  <h4 class="modal-title">Lançar Interação</h4>
                                </div>
                              </div>
                              
                                
                              <div class="row">
                                <div class="col-md-3 form-group">
                                  <label>Data Lançamento:</label><br>
                                  <input-data-hora-picker class="data-hora form-control" v-model="interacao.dataLancamento" />
                                </div>
                                <div class="form-group col-sm-4 col-md-4">
                                  <label>Motivo de Interação:</label>
                                  <select class="pula form-control custom" v-model="interacao.motivoInteracaoId">
                                    <option v-for="motivoInteracao in motivosInteracoes" v-bind:value="motivoInteracao.id">{{motivoInteracao.nome}}</option>
                                  </select>
                                </div>
                                <div class="form-group col-sm-4 col-md-4">
                                  <label>Motivo de Contato:</label>
                                  <select class="pula form-control custom" v-model="interacao.motivoContatoId">
                                    <option v-for="motivoContato in motivosContatos" v-bind:value="motivoContato.id">{{motivoContato.nome}}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-sm-12 col-md-12">
                                  <label>Titular:</label>
                                  <input v-model="interacao.titularId" type="hidden" name="titularInteracoesId" />
                                  <input v-model="interacao.titularTipo" type="hidden" name="titularInteracoesTipo" /><br>
                                  <strong>{{interacao.titularNome}}</strong>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-sm-12 col-md-12">
                                  <label>Descrição:</label><br> 
                                  <textarea rows="4" class="pula form-control" v-validate="'required'" v-model="interacao.descricao" />
                                </div>
                              </div>
                              
                              <div class="row">
                                <div class="form-group col-sm-9 col-md-9"></div>
                                <div class="form-group col-sm-3 col-md-3">
                                  <button id="imprimirVendaModal" type="button" class="btn btn-block btn-success" v-on:click="gravarInteracao">
                                    <i v-if="isLoading" class="fa fa-spinner fa-spin"></i> Gravar
                                  </button>
                                </div>
                              </div>
                              <div style="height: 250px; overflow: auto;">
                                <table
                                  class="responsive datatable_ajax display table table-striped table-hover"
                                  width="100%">
                                  <thead class="thead-light">
                                    <th width="60">Código</th>
                                    <th width="150">Tipo</th>
                                    <th width="150">Contato</th>
                                    <th width="150">Data Lançamento</th>
                                    <th>Descrição</th>
                                    <th width="150">Usuário</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="interacao in dadosVeiculoAcoesCliente">
                                      <td>{{interacao.id}}</td>
                                      <td>{{interacao.motivoInteracaoNome}}</td>
                                      <td>{{interacao.motivoContatoNome}}</td>
                                      <td>{{interacao.dataLancamento}}</td>
                                      <td>{{interacao.descricao}}</td>
                                      <td>{{interacao.usuarioNome}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalDadosVeiculo = false">Fechar</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="loading" v-if="processando">
              <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
              </div>
            </div>
            <div class="tabbable">
                <!-- Only required for left/right tabs -->
                <ul class="nav nav-tabs">
                  <li class="nav-item active"><a href="#tabDash1" data-toggle="tab" class="nav-link active">Veículos</a></li>
                  <li class="nav-item"><a href="#tabDash2" data-toggle="tab" class="nav-link" v-on:click="buscarDashboardJornadaMotoristas()" >Jornadas por Motorista</a></li>
                  <li class="nav-item"><a href="#tabDash3" data-toggle="tab" class="nav-link" v-on:click="buscarDashboardJornadaVeiculos()" >Motoristas Embarcados</a></li>

                  <li class="nav-item"><a href="#tabDash4" data-toggle="tab" class="nav-link">Jornadas Diário</a></li>
                  <li class="nav-item"><a href="#tabDash5" data-toggle="tab" class="nav-link">Jornadas Hora Extra</a></li>
                  <li class="nav-item"><a href="#tabDash6" data-toggle="tab" class="nav-link">Jornadas Acumulado</a></li>
                  
                  <!-- <li class="nav-item"><a href="#tabDash3" data-toggle="tab" class="nav-link">Ações</a></li> -->
                </ul>

                <div class="tab-content">
                  <div class="tab-pane active" id="tabDash1">
                    <div class="row">
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <div class="card text-center">
                          <div class="card-body">
                            <h4 class="card-title">Total de Veículos</h4>
                            <p class="card-text" style="font-size: 50px;">{{totalVeiculos}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <div class="card text-center">
                          <div class="card-body">
                            <h4 class="card-title">Veículos Monitorados</h4>
                            <p class="card-text" style="font-size: 50px;">{{totalVeiculosMonitorados}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="">
                      <div class="">
                        <div class="row">
                          <div class="col-sm-8 col-md-8 col-lg-8 form-group">
                            <label>Busca</label>
                            <input id="busca" name="busca" class="form-control" type="text" v-model="busca" v-on:keyup.enter="buscarAlertaSemTransmissao"> 
                          </div>
                          <div class="col-sm-2 col-md-2 col-lg-2 no-gutter">
                            <label>Sem Transmissao</label>
                            <input id="velocidade" name="velocidade" class="form-control" type="text" v-model="semTransmissao" v-on:keyup.enter="buscarAlertaSemTransmissao">
                          </div>
                          <div class="col-sm-2 col-md-2 col-lg-2 atualizacao no-gutter">
                            <label>&nbsp;</label><br>
                            <button class="btn btn-success btn-block" v-on:click="buscarAlertaSemTransmissao">Buscar</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12">
                        <h4 class="card-title">Veículos Sem Transmissão</h4>
                        <div id="dados-grid-sem-transmissao">
                          <table class="table table-responsive-sm table-hover table-outline mb-0">
                            <thead class="thead-light">
                              <tr>
                                <th style="width: 120px">Data e Hora</th>
                                <th style="width: 250px">Descrição do Veículo</th>
                                <th>Ponto mais próximo</th>
                                <th style="width: 60px">Km/h</th>
                                <th style="width: 20px">IGN</th>
                                <th style="width: 21px">GPS</th>
                                <th style="width: 24px">GSM</th>
                                <th style="width: 26px">MOV</th>
                                <th style="width: 31px">Tensão</th>
                              </tr>
                            </thead>
                            <tbody v-for="(grid, i) in veiculosAlertaSemTransmissao">
                              <template v-if="i === 0">
                                <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                  <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                                </tr>
                              </template>
                              <template v-if="i > 0">
                                <template v-if="veiculosAlertaSemTransmissao[i].clienteIdVeiculo != veiculosAlertaSemTransmissao[i-1].clienteIdVeiculo">
                                <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                  <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                                </tr>
                                </template>
                              </template>
                              <tr>
                                <td><small class="text-muted">{{grid.dataHora}}</small></td>
                                <td>
                                  <template v-if="grid.vencidos > 0">
                                    <img src="/static/images/dinheiro.png" v-tooltip="'Possui débitos vencidos'"/> 
                                  </template>
                                  <template v-if="$auth.check('P110')">
                                    <small class="text-muted"><a href="#" v-on:click="mostrarDadosVeiculo(grid.idVeiculo)" > {{grid.descricaoVeiculo}}</a></small>
                                  </template>
                                  <template v-else> 
                                    <small class="text-muted">{{grid.descricaoVeiculo}}</small>
                                  </template>
                                </td>
                                <td><small class="text-muted">{{grid.pontoMaisProximo}}</small></td>
                                <td><small class="text-muted">{{formatarVelocidade(grid.velocidade)}}</small></td>
                                <td>
                                  <template v-if="grid.ignicao">
                                    <img src="/static/images/true.png" />
                                  </template>
                                  <template v-else>
                                    <img src="/static/images/false.png" />
                                  </template>
                                </td>
                                <td>
                                  <template v-if="grid.gps">
                                    <img src="/static/images/true.png" />
                                  </template>
                                  <template v-else>
                                    <img src="/static/images/false.png" />
                                  </template>
                                </td>
                                <td>
                                  <template v-if="grid.gprs">
                                    <img src="/static/images/true.png" />
                                  </template>
                                  <template v-else>
                                    <img src="/static/images/false.png" />
                                  </template>
                                </td>
                                <td>
                                  <template v-if="grid.movimento">
                                    <img src="/static/images/true.png" />
                                  </template>
                                  <template v-else>
                                    <img src="/static/images/false.png" />
                                  </template>
                                </td>
                                <td><small class="text-muted">{{formatarVelocidade(grid.tensao)}}</small></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="rodape">
                          Total de veículos em alerta: {{veiculosAlertaSemTransmissaoTotal}} 
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="tab-pane" id="tabDash2">
                    <span class="pull-right">
                      <template v-if="!atualizandoDashboardJornadaMotoristas">
                        <span v-on:click="buscarDashboardJornadaMotoristas()" v-tooltip="'Atualizar'">
                          Atualizar
                          <i class="fas fa-sync"></i>
                        </span>
                      </template>
                      <template v-else>
                        <span  v-tooltip="'Atualizando'"> 
                          Atualizando
                          <i class="fas fa-sync fa-spin" v-tooltip="'Atualizando'" v-if="atualizandoDashboardJornadaMotoristas"></i>
                        </span>
                      </template>
                    </span>
                    <table class="table table-responsive-sm table-hover table-outline mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th>Motorista</th>
                          <th style="width: 120px">Veículo</th>
                          <th style="width: 120px">Última Macro</th>
                          <th style="width: 150px">Horário Macro</th>
                          <th style="width: 30px">Bat.</th>
                          <th style="width: 70px">Início de Jornada</th>
                          <th style="width: 70px">Alim.</th>
                          
                        </tr>
                      </thead>
                      <tbody v-for="(grid, i) in dashboardJornadaMotoristas">
                        <tr>
                          <template v-if="grid.ultimaMacro !== null">
                            <td>
                                {{grid.motoristaNome}}<br>
                                <small class="text-muted">{{grid.clienteNome}}</small>
                            </td>
                            <td>
                                {{grid.veiculoDescricao}}<br>
                            </td>
                            <td>
                              <small class="text-muted">{{grid.ultimaMacro}}</small><br>
                              <small class="text-muted">{{grid.ultimaMacroTempo}}</small>
                            </td>
                            <td>
                                <small class="text-muted"><strong>{{grid.ultimaMacroDataHora}}</strong></small>
                                <template v-if="grid.latitudeMacro === null || grid.latitudeMacro === 0">
                                  <span class="text-secondary" style="font-size: 20px; margin 22px;" v-tooltip="'Posição não disponível'"><i class="fas fa-map-marker-alt"></i> </span><br>
                                </template>
                                <template v-else>
                                  <span class="text-success" style="font-size: 20px; margin 22px;" v-tooltip="'Posição da Macro'" v-on:click="visualizarMapa(grid, 'macro')"><i class="fas fa-map-marker-alt"></i> </span><br>
                                </template>

                                <small class="text-muted"><strong>{{grid.ultimaAliveDataHora}}</strong></small>
                                <template v-if="grid.latitudeAlive === null || grid.latitudeAlive === 0">
                                  <span class="text-secondary" style="font-size: 20px; margin 22px;" v-tooltip="'Posição não disponível'" ><i class="fas fa-map-marker-alt"></i> </span>
                                </template>
                                <template v-else>
                                  <span class="text-success" style="font-size: 20px; margin 22px;" v-tooltip="'Posição do Keep Alive'" v-on:click="visualizarMapa(grid, 'alive')"><i class="fas fa-map-marker-alt"></i> </span>
                                </template>
                            </td>
                            <td class="text-center">
                              <template v-if="grid.bateriaMacro > 20">
                                <span class="text-success" v-tooltip="'Bateria Macro'"> {{(grid.bateriaMacro > 0 ? parseFloat(grid.bateriaMacro).toFixed(0) : '')}} </span><br>
                              </template>
                              <template v-else>
                                <span class="text-danger" v-tooltip="'Bateria Macro'"> {{(grid.bateriaMacro > 0 ? parseFloat(grid.bateriaMacro).toFixed(0) : '')}} </span><br>
                              </template>
                              <template v-if="grid.bateriaAlive > 20">
                                <span class="text-success" v-tooltip="'Bateria Keep Alive'"> {{(grid.bateriaAlive > 0 ? parseFloat(grid.bateriaAlive).toFixed(0) : '')}} </span>
                              </template>
                              <template v-else>
                                <span class="text-danger" v-tooltip="'Bateria Keep Alive'"> {{(grid.bateriaAlive > 0 ? parseFloat(grid.bateriaAlive).toFixed(0) : '')}} </span>
                              </template>
                            </td>

                            <td>
                              <small class="text-muted">{{grid.inicioJornadaDia}}</small><br>
                              <template v-if="grid.latitudeJornadaDia === null || grid.latitudeJornadaDia === 0">
                                <span class="text-secondary" style="font-size: 20px; margin 22px;" v-tooltip="'Posição não disponível'" ><i class="fas fa-map-marker-alt"></i> </span>
                              </template>
                              <template v-else>
                                <span class="text-success" style="font-size: 20px; margin 22px;" v-tooltip="'Posição da Inicio'" v-on:click="visualizarMapa(grid, 'jornada')"><i class="fas fa-map-marker-alt"></i> </span>
                              </template>
                              <template v-if="grid.bateriaJornadaDia > 20">
                                <span class="text-success" v-tooltip="'Bateria da Inicio'" > {{(grid.bateriaJornadaDia > 0 ? parseFloat(grid.bateriaJornadaDia).toFixed(0) : '')}} </span>
                              </template>
                              <template v-else>
                                <span class="text-danger" v-tooltip="'Bateria da Inicio'" > {{(grid.bateriaJornadaDia > 0 ? parseFloat(grid.bateriaJornadaDia).toFixed(0) : '')}} </span>
                              </template>
                              
                            </td>
                            <td class="text-center">
                              <small class="text-muted">{{grid.alimentacaoJornadaDia}}</small><br>
                              <span v-if="grid.alimentacaoJornadaDia !== null" class="text-success"> <i class="fas fa-utensils"></i> </span>
                              <span v-if="grid.alimentacaoJornadaDia == null" class="text-danger"> <i class="fas fa-utensils"></i> </span>
                              <template v-if="grid.latitudeAlimentacaoJornadaDia === null || grid.latitudeAlimentacaoJornadaDia === 0">
                                <span class="text-secondary" style="font-size: 20px; margin 22px;" v-tooltip="'Posição não disponível'" ><i class="fas fa-map-marker-alt"></i> </span>
                              </template>
                              <template v-else>
                                <span class="text-success" style="font-size: 20px; margin 22px;" v-tooltip="'Posição da Alimentação'" v-on:click="visualizarMapa(grid, 'alimentacao')"><i class="fas fa-map-marker-alt"></i> </span>
                              </template>
                              <template v-if="grid.bateriaAlimentacaoJornadaDia > 20">
                                <span class="text-success" v-tooltip="'Bateria da Alimentação'"> {{(grid.bateriaAlimentacaoJornadaDia > 0 ? parseFloat(grid.bateriaAlimentacaoJornadaDia).toFixed(0) : '')}} </span>
                              </template>
                              <template v-else>
                                <span class="text-danger" v-tooltip="'Bateria da Alimentação'"> {{(grid.bateriaAlimentacaoJornadaDia > 0 ? parseFloat(grid.bateriaAlimentacaoJornadaDia).toFixed(0) : '')}} </span>
                              </template>
                            </td>
                            
                          </template>
                          <template v-else>
                            <td>
                                {{grid.motoristaNome}}<br>
                                <small class="text-muted">{{grid.clienteNome}}</small>
                            </td>
                            <td colspan="6" class="text-center text-danger">
                              <h4>SEM DADOS</h4>
                            </td>
                          </template>
                          
                        </tr>
                      </tbody>
                    </table>
                  </div>


                  <div class="tab-pane" id="tabDash3">
                    <span class="pull-right">
                      <template v-if="!atualizandoDashboardJornadaVeiculos">
                        <span v-on:click="buscarDashboardJornadaVeiculos()" v-tooltip="'Atualizar'">
                          Atualizar
                          <i class="fas fa-sync"></i>
                        </span>
                      </template>
                      <template v-else>
                        <span  v-tooltip="'Atualizando'"> 
                          Atualizando
                          <i class="fas fa-sync fa-spin" v-tooltip="'Atualizando'" v-if="atualizandoDashboardJornadaVeiculos"></i>
                        </span>
                      </template>
                    </span>
                    <table class="table table-responsive-sm table-hover table-outline mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th>Veículo</th>
                          <th style="width: 350px">Motorista</th>
                          <th style="width: 250px">Distancia Percorrida</th>
                        </tr>
                      </thead>
                      <tbody v-for="(grid, i) in dashboardJornadaVeiculos">
                        <tr>
                          <template v-if="grid.ultimaMacro !== null">
                            <td>
                              {{grid.veiculoDescricao}}<br>
                              <small class="text-muted">{{grid.clienteNome}}</small>
                            </td>
                            <td>
                              <template v-if="grid.motoristaData !== grid.dataHoje">
                                <span class="text-danger">{{grid.motoristaNome}}<br></span>
                              </template>
                              <template v-else>
                                {{grid.motoristaNome}}<br>
                              </template>                              
                            </td>
                            <td>
                              <template v-if="grid.distanciaPercorrida !== null && grid.distanciaPercorrida >= 0">
                                {{parseFloat(grid.distanciaPercorrida).toFixed(0)}} Km
                              </template>
                              <template v-else>
                                0 Km
                              </template>
                              
                            </td>
                          </template>
                          <template v-else>
                            <td>
                               {{grid.veiculoDescricao}}<br>
                            </td>
                            <td colspan="6" class="text-center text-danger">
                              <h4>SEM DADOS</h4>
                            </td>
                          </template>
                          
                        </tr>
                      </tbody>
                    </table>
                  </div>



                  
                  <div class="tab-pane" id="tabDash4">
                    <div class="row">
                      <div class="col-sm-9 col-md-9">
                        <div class="form-group has-feedback">
                          <label class="label-filtros">Buscar:</label><br>
                          <input class="form-control hasclear" type="text" v-model="campoBuscaDashboardJornadaDiario" v-on:keyup.enter="buscarDashboardJornadaDiario()"/>
                          <span id="limparbusca" class="glyphicon glyphicon-remove-circle"></span>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <label class="label-filtros">Data:</label><br>
                        <input-data-picker v-model="dataDashboardJornadaDiario" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                      </div>
                      <div class="col-md-1">
                        <div class="form-group">
                          <label class="label-filtros">&nbsp;</label><br>
                          <input class="btn btn-block btn-success" type="button" v-on:click="buscarDashboardJornadaDiario()" value="Buscar">
                        </div>
                      </div>
                    </div>
                    <div id="dashboardJornadaDiario">
                      <table id="tableDashboardJornadaDiario" class="table table-responsive-sm table-hover table-outline mb-0" style="table-layout: fixed;">
                        <thead class="thead-light">
                          <tr>
                            <th width="350">Funcionário</th>
                            <th width="250">Veículo</th>
                            <th width="100">Tipo</th>
                            <th width="150">Data Hora Inicial</th>
                            <th width="150">Data Hora Final</th>
                            <th width="100">Interjornada</th>
                            <th width="100">Jornada</th>
                            <th width="100">Trabalhado</th>
                            <th width="130">Hora extra Total</th>
                            <th width="130">Adicional Noturno</th>
                            <th width="150">Hora Indenizada</th>
                            <th width="150">Descanso Direção</th>
                            <th width="150">Alimentação</th>
                            
                          </tr>
                        </thead>
                        <tbody v-for="(grid, i) in dashboardJornadaDiario">
                          <template v-if="i === 0">
                            <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                              <td colspan="14"><strong>{{grid.clienteNome}}</strong></td>
                            </tr>
                          </template>
                          <template v-if="i > 0">
                            <template v-if="dashboardJornadaDiario[i].clienteNome !== dashboardJornadaDiario[i-1].clienteNome">
                              <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                <td colspan="14"><strong>{{grid.clienteNome}}</strong></td>
                              </tr>
                            </template>
                          </template>
                          <tr>
                            <template v-if="grid.dataHoraInicial !== null">  
                              <td>
                                {{grid.motoristaNome}}
                              </td>
                              <td>
                                {{grid.veiculoDescricao}}
                              </td>
                              <td>
                                {{grid.tipo}}
                              </td>
                              <td>
                                <template v-if="grid.dataHoraInicial === '01/01/0001 00:00:00'">
                                  ---
                                </template>
                                <template v-else>
                                  {{grid.dataHoraInicial}}
                                </template>
                              </td>
                              <td>
                                <template v-if="grid.dataHoraFinal === '01/01/0001 00:00:00'">
                                  ---
                                </template>
                                <template v-else>
                                  {{grid.dataHoraFinal}}
                                </template>
                              </td>
                              <td>
                                {{grid.tempoInterJornada}}
                              </td>
                              <td>
                                {{grid.tempoJornada}}
                              </td>
                              <td>
                                {{grid.tempoTrabalhado}}
                              </td>
                              <td>
                                {{grid.tempoHoraExtraTotal}}
                              </td>
                              <td>
                                {{grid.tempoAdicionalNoturno}}
                              </td>
                              <td>
                                {{grid.tempoHoraIndenizada}}
                              </td>
                              <td>
                                {{grid.tempoDescansoDirecao}}
                              </td>
                              <td>
                                <template v-if="grid.tempoAlimentacaoErro">
                                  <span class="text-danger">
                                    {{grid.tempoAlimentacao}}
                                  </span>
                                </template>
                                <template v-else>
                                  {{grid.tempoAlimentacao}}
                                </template>
                              </td>
                              
                            </template>
                            <template v-else>
                              <td>
                                {{grid.motoristaNome}}<br>
                              </td>
                              <td colspan="11" class="text-center text-danger">
                                <h4>SEM DADOS</h4>
                              </td>
                            </template>
                          </tr>
                           <template v-if="i < dashboardJornadaDiario.length-1">
                             <tr>
                              <template v-if="dashboardJornadaDiario[i].clienteNome !== dashboardJornadaDiario[i+1].clienteNome">
                                <td></td><td></td><td></td><td></td>
                                <td></td><td></td><td></td><td></td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraTotal}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoAdicionalNoturno}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraIndenizada}}</span></strong>
                                </td>
                                <td></td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoAlimentacao}}</span></strong>
                                </td>   
                              </template>
                             </tr>
                            </template>
                            <template v-if="i === (dashboardJornadaDiario.length-1)">
                              <tr>
                                <td></td><td></td><td></td><td></td>
                                <td></td><td></td><td></td><td></td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraTotal}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoAdicionalNoturno}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraIndenizada}}</span></strong>
                                </td>
                                <td></td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoAlimentacao}}</span></strong>
                                </td>     
                              </tr>                     
                            </template>
                            <template v-if="i === (dashboardJornadaDiario.length-1)">
                                <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                                <td>
                                  <strong>{{grid.somaTotalTempoHoraExtraTotal}}</strong>
                                </td>
                                <td>
                                  <strong>{{grid.somaTotalTempoAdicionalNoturno}}</strong>
                                </td>
                                <td>
                                  <strong>{{grid.somaTotalTempoHoraIndenizada}}</strong>
                                </td>
                                <td></td>
                                <td>
                                  <strong>{{grid.somaTotalTempoAlimentacao}}</strong>
                                </td>                          
                            </template>

                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="tab-pane" id="tabDash5">
                    <div class="row">
                      <div class="col-md-9">
                        <div class="form-group has-feedback">
                          <label class="label-filtros">Buscar:</label><br>
                          <input class="form-control hasclear" type="text" v-model="campoBuscaDashboardJornadaHoraExtra" v-on:keyup.enter="buscarDashboardJornadaHoraExtra()"/>
                          <span id="limparbusca" class="glyphicon glyphicon-remove-circle"></span>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <label class="label-filtros">Data:</label><br>
                        <input-data-picker v-model="dataDashboardJornadaHoraExtra" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                      </div>
                      <div class="col-md-1">
                        <div class="form-group">
                          <label class="label-filtros">&nbsp;</label><br>
                          <input class="btn btn-block btn-success" type="button" v-on:click="buscarDashboardJornadaHoraExtra()" value="Buscar">
                        </div>
                      </div>
                    </div>
                    <div id="dashboardJornadaDiario">
                      <table id="tableDashboardJornadaDiario" class="table table-responsive-sm table-hover table-outline mb-0" style="table-layout: fixed;">
                        <thead class="thead-light">
                          <tr>
                            <th width="350">Funcionário</th>
                            <th width="250">Veículo</th>
                            <th width="100">Tipo</th>
                            <th width="150">Data Hora Inicial</th>
                            <th width="150">Data Hora Final</th>
                            <th width="100">Jornada</th>
                            <th width="100">Trabalhado</th>
                            <th width="150">Hora Extra Normal 1</th>
                            <th width="150">Hora Extra Normal 2</th>
                            <th width="150">Hora Extra Noturna 1</th>
                            <th width="150">Hora Extra Noturna 2</th>	
                            <th width="130">Hora Extra Total</th>                          
                          </tr>
                        </thead>
                        <tbody v-for="(grid, i) in dashboardJornadaHoraExtra">
                          
                          <template v-if="i === 0">
                            <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                              <td colspan="14"><strong>{{grid.clienteNome}}</strong></td>
                            </tr>
                          </template>
                          <template v-if="i > 0">
                            <template v-if="dashboardJornadaHoraExtra[i].clienteNome !== dashboardJornadaHoraExtra[i-1].clienteNome">
                              <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                <td colspan="14"><strong>{{grid.clienteNome}}</strong></td>
                              </tr>
                            </template>
                          </template>
                          <tr>
                            <template v-if="grid.dataHoraInicial !== null">  
                              <td>
                                {{grid.motoristaNome}}
                              </td>
                              <td>
                                {{grid.veiculoDescricao}}
                              </td>
                              <td>
                                {{grid.tipo}}
                              </td>
                              <td>
                                {{grid.dataHoraInicial}}
                              </td>
                              <td>
                                {{grid.dataHoraFinal}}
                              </td>
                              <td>
                                {{grid.tempoJornada}}
                              </td>
                              <td>
                                {{grid.tempoTrabalhado}}
                              </td>
                              <td>
                                {{grid.tempoHoraExtraNormal1}}
                              </td>
                              <td>
                                {{grid.tempoHoraExtraNormal2}}
                              </td>
                              <td>
                                {{grid.tempoHoraExtraNoturna1}}
                              </td>
                              <td>
                                {{grid.tempoHoraExtraNoturna2}}
                              </td>
                              <td>
                                {{grid.tempoHoraExtraTotal}}
                              </td>
                            </template>
                            <template v-else>
                              <td>
                                {{grid.motoristaNome}}<br>
                              </td>
                              <td colspan="11" class="text-center text-danger">
                                <h4>SEM DADOS</h4>
                              </td>
                            </template>                       
                          </tr>
                          <template v-if="i < dashboardJornadaHoraExtra.length-1">
                             <tr>
                              <template v-if="dashboardJornadaHoraExtra[i].clienteNome !== dashboardJornadaHoraExtra[i+1].clienteNome">
                                <td></td><td></td><td></td><td></td>
                                <td></td><td></td><td></td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal1}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal2}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna1}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna2}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraTotal}}</span></strong>
                                </td>
                              </template>
                             </tr>
                            </template>
                            <template v-if="i === (dashboardJornadaHoraExtra.length-1)">
                              <tr>
                                <td></td><td></td><td></td><td></td>
                                <td></td><td></td><td></td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal1}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal2}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna1}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna2}}</span></strong>
                                </td>
                                <td>
                                  <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraTotal}}</span></strong>
                                </td>     
                              </tr>                     
                            </template>
                            <template v-if="i === (dashboardJornadaHoraExtra.length-1)">
                                <td></td><td></td><td></td><td></td>
                                <td></td><td></td><td></td>
                                <td>
                                  <strong>{{grid.somaTotalTempoHoraExtraNormal1}}</strong>
                                </td>
                                <td>
                                  <strong>{{grid.somaTotalTempoHoraExtraNormal2}}</strong>
                                </td>
                                <td>
                                  <strong>{{grid.somaTotalTempoHoraExtraNoturna1}}</strong>
                                </td>
                                <td>
                                  <strong>{{grid.somaTotalTempoHoraExtraNoturna2}}</strong>
                                </td>
                                <td>
                                  <strong>{{grid.somaTotalTempoHoraExtraTotal}}</strong>
                                </td>                      
                            </template>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="tab-pane" id="tabDash6">
                    <div class="row">
                      <div class="col-md-2">
                        <label class="label-filtros">Data Inicial:</label><br>
                        <input-data-picker v-model="dataInicialDashboardJornadaAcumulado" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                      </div>
                      <div class="col-md-2">
                        <label class="label-filtros">Data Final:</label><br>
                        <input-data-picker v-model="dataFinalDashboardJornadaAcumulado" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                      </div>
                      <div class="col-md-1">
                        <div class="form-group">
                          <label class="label-filtros">&nbsp;</label><br>
                          <input class="btn btn-block btn-success" type="button" v-on:click="buscarDashboardJornadaAcumulado()" value="Buscar">
                        </div>
                      </div>
                    </div>
                    <div id="dashboardJornadaDiario">
                      <table id="tableDashboardJornadaDiario" class="table table-responsive-sm table-hover table-outline mb-0">
                        <thead class="thead-light">
                          <tr>
                            <th>Dia</th>
                            <th>Hora Extra Normal 1</th>
                            <th>Hora Extra Normal 2</th>
                            <th>Hora Extra Noturna 1</th>
                            <th>Hora Extra Noturna 2</th>
                            <th>Hora Extra Total</th>
                            <th>Adicional Noturno</th>
                            <th>Hora Indenizada</th>
                            <th>Alimentação Irregular</th>
                          </tr>
                        </thead>
                        <tbody v-for="(grid, i) in dashboardJornadaAcumulado">
                            <template v-if="i === 0">
                              <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                <td colspan="14"><strong>{{grid.clienteNome}}</strong></td>
                              </tr>
                            </template>
                            <template v-if="i > 0">
                              <template v-if="dashboardJornadaAcumulado[i].clienteNome !== dashboardJornadaAcumulado[i-1].clienteNome">
                                <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                  <td colspan="14"><strong>{{grid.clienteNome}}</strong></td>
                                </tr>
                              </template>
                            </template>
                            <tr>
                              <template v-if="grid.data !== null">  
                                <td>
                                  {{grid.data}}
                                </td>
                                <td>
                                  {{grid.tempoHoraExtraNormal1}}
                                </td>
                                <td>
                                  {{grid.tempoHoraExtraNormal2}}
                                </td>
                                <td>
                                  {{grid.tempoHoraExtraNoturna1}}
                                </td>
                                <td>
                                  {{grid.tempoHoraExtraNoturna2}}
                                </td>
                                <td>
                                  {{grid.tempoHoraExtraTotal}}
                                </td>
                                <td>
                                  {{grid.tempoAdicionalNoturno}}
                                </td>
                                <td>
                                  {{grid.tempoHoraIndenizada}}
                                </td>
                                <td>
                                  <template v-if="grid.tempoAlimentacaoErro">
                                    <span class="text-danger">
                                      {{grid.tempoAlimentacao}}
                                    </span>
                                  </template>
                                  <template v-else>
                                    {{grid.tempoAlimentacao}}
                                  </template>
                                </td>
                                
                              </template>
                              <template v-else>
                                <td>
                                  {{grid.motoristaNome}}<br>
                                </td>
                                <td colspan="11" class="text-center text-danger">
                                  <h4>SEM DADOS</h4>
                                </td>
                              </template>
                            </tr>
                            <template v-if="i < dashboardJornadaAcumulado.length-1">
                              <tr>
                                <template v-if="dashboardJornadaAcumulado[i].clienteNome !== dashboardJornadaAcumulado[i+1].clienteNome">
                                  <td></td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal1}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal2}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna1}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna2}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraTotal}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoAdicionalNoturno}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraIndenizada}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoAlimentacao}}</span></strong>
                                  </td>
                                </template>
                              </tr>
                              </template>
                              <template v-if="i === (dashboardJornadaAcumulado.length-1)">
                                <tr>
                                  <td></td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal1}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNormal2}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna1}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraNoturna2}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraExtraTotal}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoAdicionalNoturno}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoHoraIndenizada}}</span></strong>
                                  </td>
                                  <td>
                                    <strong><span class="text-center text-primary">{{grid.somaTempoAlimentacao}}</span></strong>
                                  </td>   
                                </tr>                     
                              </template>
                              <template v-if="i === (dashboardJornadaAcumulado.length-1)">
                                <td></td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoHoraExtraNormal1}}</strong>
                                  </td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoHoraExtraNormal2}}</strong>
                                  </td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoHoraExtraNoturna1}}</strong>
                                  </td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoHoraExtraNoturna2}}</strong>
                                  </td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoHoraExtraTotal}}</strong>
                                  </td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoAdicionalNoturno}}</strong>
                                  </td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoHoraIndenizada}}</strong>
                                  </td>
                                  <td>
                                    <strong>{{grid.somaTotalTempoAlimentacao}}</strong>
                                  </td>          
                              </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
              </div>



            
          </div>
        </div>
      </div>
    </div>
  </div>          
</template>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCNdW9zNp4aaHrlBIX8r7YnB3Axv4kvDv0"></script>
<script>
import axios from 'axios'
import LineChart from './LineChart.js'
import PieChart from './PieChart.js'
import BarChart from './BarChart.js'
export default {
  components: {
    LineChart,
    PieChart,
    BarChart
  },
  data () {
    return {
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      atualizarGrid: 0,
      atualizarGridInterval: '',
      selecionada: '0',
      veiculosAlertaBateria: [],
      veiculosAlertaBateriaTotal: '0',
      veiculosAlertaSemTransmissao: [],
      veiculosAlertaSemTransmissaoTotal: '0',
      totalVeiculos: '0',
      totalVeiculosMonitorados: '0',
      processando: false,
      showModalDadosVeiculo: false,
      dadosVeiculo: [],
      dadosVeiculoContatoCliente: [],
      dadosVeiculoContatoClientePaga: [],
      dadosVeiculoAcoesCliente: [],
      dashboardJornadaMotoristas: [],
      dashboardJornadaVeiculos: [],
      dashboardJornadaDiario: [],
      dashboardJornadaHoraExtra: [],
      dashboardJornadaAcumulado: [],
      atualizandoDashboardJornadaMotoristas: false,
      atualizandoDashboardJornadaVeiculos: false,
      atualizandoDashboardJornadaDiario: false,
      atualizandoDashboardJornadaHoraExtra: false,
      atualizandoDashboardJornadaAcumulado: false,
      campoBuscaDashboardJornadaDiario: '',
      dataDashboardJornadaDiario: this.dataOntem(),
      campoBuscaDashboardJornadaHoraExtra: '',
      dataDashboardJornadaHoraExtra: this.dataOntem(),
      dataInicialDashboardJornadaAcumulado: this.dataOntem(),
      dataFinalDashboardJornadaAcumulado: this.dataOntem(),
      interacao: {
        dataLancamento: this.dataHoraAtual(),
        titularId: '0',
        titularTipo: '',
        titularNome: '',
        titular: '',
        descricao: '',
        motivoInteracaoId: '0',
        motivoInteracaoNome: ''
      },
      motivosInteracoes: [],
      motivosContatos: [],
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null
    }
  },
  created: function () {
    // this.buscarAlertaBateria()
    // this.buscarAlertaBateriaTotal()
    this.buscarAlertaSemTransmissao()
    // this.buscarAlertaSemTransmissaoTotal()
    this.buscarTotalVeiculos()
    this.buscarTotalVeiculosMonitorados()
  },
  methods: {
    buscarTotalVeiculos: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/totalVeiculos?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.totalVeiculos = dadosCadastro
        self.processando = false
      })
    },
    buscarTotalVeiculosMonitorados: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/totalVeiculosMonitorados?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.totalVeiculosMonitorados = dadosCadastro
        self.processando = false
      })
    },
    buscarAlertaBateria: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/alertaBateria?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.veiculosAlertaBateria = dadosCadastro.dados
        self.processando = false
      })
    },
    buscarAlertaBateriaTotal: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/alertaBateriaTotal?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.veiculosAlertaBateriaTotal = dadosCadastro
        self.processando = false
      })
    },
    buscarAlertaSemTransmissao: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/alertaSemTransmissao?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.veiculosAlertaSemTransmissao = dadosCadastro.dados
        self.processando = false
        self.buscarAlertaSemTransmissaoTotal()
      })
    },
    buscarAlertaSemTransmissaoTotal: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/alertaSemTransmissaoTotal?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.veiculosAlertaSemTransmissaoTotal = dadosCadastro
        self.processando = false
      })
    },
    mostrarDadosVeiculo: function (veiculo) {
      let self = this
      self.dadosVeiculo = []
      self.processando = true
      self.showModalDadosVeiculo = true
      self.interacao.dataLancamento = self.dataHoraAtual()
      self.interacao.titularId = '0'
      self.interacao.titularTipo = ''
      self.interacao.titularNome = ''
      self.interacao.titular = ''
      self.interacao.descricao = ''
      self.interacao.motivoInteracaoId = '0'
      self.interacao.motivoInteracaoNome = ''
      self.buscarGridDadosVeiculo(veiculo)
      self.buscarMotivosInteracoes()
      self.buscarMotivosContatos()
    },
    buscarGridDadosVeiculo: function (veiculo) {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/gridDadosVeiculo?veiculo=' + veiculo
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculo = dadosCadastro
        self.processando = false
      })
    },
    buscarGridDadosVeiculoContatoCliente: function (veiculo) {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clienteId
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculoContatoCliente = dadosCadastro
        self.processando = false
      })
    },
    buscarGridDadosVeiculoContatoClientePaga: function (veiculo) {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clientePagaId
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculoContatoClientePaga = dadosCadastro
        self.processando = false
      })
    },
    buscarMotivosInteracoes: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarMotivosInteracoesAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.motivosInteracoes = response.data
        for (let i = 0; i < self.motivosInteracoes.length; i++) {
          if (i === 0) {
            self.interacao.motivoInteracaoId = self.motivosInteracoes[i].id
          }
        }
      })
    },
    buscarMotivosContatos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarMotivosContatosAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.motivosContatos = response.data
        for (let i = 0; i < self.motivosContatos.length; i++) {
          if (i === 0) {
            self.interacao.motivoContatoId = self.motivosContatos[i].id
          }
        }
      })
    },
    buscarGridDadosVeiculoAcoesCliente: function (veiculoo) {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/clientesHistoricoInteracoes/' + self.dadosVeiculo.clienteId
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculoAcoesCliente = dadosCadastro
        self.interacao.titularId = self.dadosVeiculo.clienteId
        self.interacao.titularTipo = 'C'
        self.interacao.titularNome = self.dadosVeiculo.clienteNome
        self.processando = false
      })
    },
    gravarInteracao: function (titular) {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.interacao))
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.isLoading = true
          var url = '/api/titularesInteracoes/salvar'
          axios.post(url, JSON.stringify(self.interacao), config)
          .then(function (response) {
            console.log(response)
            if (response.status === 200) {
              self.$toastr('success', 'Interação gravada com sucesso.', 'Atenção')
              self.buscarGridDadosVeiculoAcoesCliente()
              self.isLoading = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    },

    buscarDashboardJornadaMotoristas: function () {
      var self = this
      self.processando = true
      self.atualizandoDashboardJornadaMotoristas = true
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/jornadaDashboardMotorista/'
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.dashboardJornadaMotoristas = response.data
        self.processando = false
        self.atualizandoDashboardJornadaMotoristas = false
      })
    },
    buscarDashboardJornadaVeiculos: function () {
      var self = this
      self.processando = true
      self.atualizandoDashboardJornadaVeiculos = true
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/jornadaDashboardVeiculo/'
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.dashboardJornadaVeiculos = response.data
        self.processando = false
        self.atualizandoDashboardJornadaVeiculos = false
      })
    },
    buscarDashboardJornadaDiario: function () {
      var self = this
      self.processando = true
      self.atualizandoDashboardJornadaDiario = true
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/jornadaDashboardDiario?data=' + self.dataDashboardJornadaDiario + '&busca=' + self.campoBuscaDashboardJornadaDiario
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.dashboardJornadaDiario = response.data
        self.processando = false
        self.atualizandoDashboardJornadaDiario = false
      })
    },
    buscarDashboardJornadaHoraExtra: function () {
      var self = this
      self.processando = true
      self.atualizandoDashboardJornadaHoraExtra = true
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/jornadaDashboardHoraExtra?data=' + self.dataDashboardJornadaHoraExtra + '&busca=' + self.campoBuscaDashboardJornadaHoraExtra
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.dashboardJornadaHoraExtra = response.data
        self.processando = false
        self.atualizandoDashboardJornadaHoraExtra = false
      })
    },
    buscarDashboardJornadaAcumulado: function () {
      var self = this
      self.processando = true
      self.atualizandoDashboardJornadaAcumulado = true
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/jornadaDashboardAcumulado?dataInicial=' + self.dataInicialDashboardJornadaAcumulado + '&dataFinal=' + self.dataFinalDashboardJornadaAcumulado
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.dashboardJornadaAcumulado = response.data
        self.processando = false
        self.atualizandoDashboardJornadaAcumulado = false
      })
    },
    async visualizarMapa (posicao, tipo) {
      let self = this
      self.removerMarkers()
      self.showModalMapa = true
      await new Promise(resolve => setTimeout(resolve, 3000))
      self.adicionarMarker(posicao, tipo)
    },
    adicionarMarker (posicao, tipo) {
      let self = this
      self.removerMarkers()
      let marker = null
      let bounds = null
      let myLatLng = null
      if (tipo === 'macro') {
        marker = {
          lat: posicao.latitudeMacro,
          lng: posicao.longitudeMacro
        }
      } else if (tipo === 'alive') {
        marker = {
          lat: posicao.latitudeAlive,
          lng: posicao.longitudeAlive
        }
      } else if (tipo === 'jornada') {
        marker = {
          lat: posicao.latitudeJornadaDia,
          lng: posicao.longitudeJornadaDia
        }
      } else if (tipo === 'alimentacao') {
        marker = {
          lat: posicao.latitudeAlimentacaoJornadaDia,
          lng: posicao.longitudeAlimentacaoJornadaDia
        }
      }
      self.markers.push({ position: marker, motorista: posicao.motoristaNome, dataHora: posicao.dataHora })
      // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
      self.center = marker
      myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
      if (bounds === null) {
        bounds = new window.google.maps.LatLngBounds()
      }
      bounds.extend(myLatLng)
      self.$nextTick(() => {
        console.log(bounds)
        self.setMapBounds()
      })
      self.currentPlace = null
    },
    removerMarkers () {
      let self = this
      self.markers = []
      self.path = []
    },
    setMapBounds () {
      let self = this
      var bounds = new window.google.maps.LatLngBounds()
      for (let i = 0; i < this.markers.length; i++) {
        let myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng })
        bounds.extend(myLatLng)
      }
      // this.markers.forEach(marker => {
      //   bounds.extend(new window.google.maps.LatLng(marker.position.lat, marker.position.lng))
      // })
      setTimeout(function () {
        self.$refs.map.fitBounds(bounds)
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18)
        }
      }, 500)
      // console.log(self.$refs.map.getZoom())
      console.log(self.$refs.map.$mapObject.zoom)
      console.log(self.$refs.map.zoom)
      // this.$refs.map.$mapCreated.then((map) => {
      //   map.fitBounds(bounds)
      // })
      // Vue.$gmapDefaultResizeBus.$emit("resize")
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = ''
      // this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>'
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/Dashboard.vue